/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SlaFileListAliases {
  CONTEXTUAL_BAR_SLA_FILE = 'contextual-bar-sla-file',
  FETCH_SLA_FILE = 'fetch-sla-file',
  LAYOUT_SLA_FILE = 'layout-sla-file',
  PANEL_SLA_FILE = 'panel-sla-file',
  TABLE_COLUMN_ACTIONS = 'table-column-actions',
  TABLE_COLUMN_FILE_NAME = 'table-column-file-name',
  TABLE_COLUMN_LAST_MODIFICATION = 'table-column-last-modification',
  TABLE_COLUMN_SIZE = 'table-column-size',
  TABLE_SLA_FILE = 'table-sla-file',
}
export { SlaFileListAliases };
